module.exports = __webpack_public_path__ + "img/ESP-001.e939684a.png";